module.exports = __webpack_public_path__ + "img/instagram.964bb264.svg";